import React from 'react';

export default () => (
  <button
    className="site-header__back-button bvs-icon is-arrow-left"
    type="button"
    onClick={() => { window.history.back(); }}
  />
);

// TODO: It would be great to have Icon rendering button elements
